import {
  Button,
  Card,
  CardContent,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useCallback, useMemo } from "react";
import { TAG_COLOR } from "../../constants/const";
import { strings } from "../../I18n";
import E_Bike from "../../images/bikes/bicycle.png";
import Bike from "../../images/bikes/bike.png";
import {
  convertDateFromUtc0ToLocal,
  convertDateToHumanReadableFormat,
  modifyCurrencyToSymbol,
  modifyCurrencyToSymbolAndValue,
} from "../../utils/utils";
import { useStyles } from "../modal/pricingPlanModal/styles";
import Tag from "../Tags";

const LegacyWalletView = ({
  userLedgerList,
  userDetailInfo,
  userDetailInfoLoading,
  state,
  renderCustomTable,
  openAdjustModal,
}) => {
  const classes = useStyles();

  const formatDateAndTimeForLedger = (date) => {
    const dateObj = new Date(date);
    const dateStr = dateObj.toLocaleDateString("en-US");
    const timeStr = dateObj.toLocaleTimeString("en-US");
    return `${dateStr} ${timeStr}`;
  };

  const pricingPlan = useCallback(
    (plan) => (
      <>
        <Card elevation={4} className={classes.card}>
          <CardContent>
            <Typography className={classes.planType} variant="body2">
              {plan?.typeDisplayValue}
            </Typography>
            <Typography className={classes.priceTextStyle}>
              {plan?.price}
            </Typography>
            {!!plan?.rules &&
              plan?.rules.map((rule) => {
                return (
                  <Paper elevation={0} key={rule?.label}>
                    <Grid
                      className={classes.planRuleStyle}
                      container={true}
                      justify="space-between"
                    >
                      <div className={classes.planRuleLableStyle}>
                        {rule?.label?.toUpperCase() === "E-BIKES" ? (
                          <img
                            className={classes.planRuleLableImageStyle}
                            src={E_Bike}
                            height="16px"
                            alt={rule.label}
                          />
                        ) : (
                          <img
                            className={classes.planRuleLableImageStyle}
                            src={Bike}
                            height="26px"
                            alt={rule.label}
                          />
                        )}
                        <span>{rule?.label}</span>
                      </div>
                      <Typography variant="subtitle2" display="inline">
                        {rule?.value}
                      </Typography>
                    </Grid>
                  </Paper>
                );
              })}
            <Typography
              className={classes.descriptionTextStyle}
              variant="caption"
            >
              {plan?.description}
            </Typography>
          </CardContent>
        </Card>
      </>
    ),
    [classes]
  );

  return (
    <div className="main-container">
      <div className="table-container">
        <div className="table-header">
          <p
            style={{
              float: "left",
            }}
          >
            {strings("descriptions.ledgerFromTo", {
              from: convertDateToHumanReadableFormat(state[0].startDate),
              to: convertDateToHumanReadableFormat(state[0].endDate),
            })}
          </p>
          <div className="adjust-balance">
            <Button
              variant="contained"
              color="primary"
              onClick={openAdjustModal}
            >
              Adjust Balance
            </Button>
          </div>
        </div>

        {renderCustomTable()}
      </div>

      <div className="user-card">
        <div className="user-card-header">
          <p>{strings("descriptions.paymentDetails")}</p>
        </div>
        {userDetailInfoLoading ? (
          <h2>{strings("descriptions.loading")}</h2>
        ) : (
          <div className="user-info-card">
            <div className="user-info-card-header">
              <div className="header-image">
                <img
                  className="header-img"
                  src="https://www.w3schools.com/howto/img_avatar.png"
                  alt="Avatar"
                />
              </div>
              <div className="user-name">
                <p>{userDetailInfo?.userName}</p>
              </div>
              <div className="user-date">
                <p>
                  {moment(userDetailInfo?.accountCreationDate).format(
                    "MMMM DD, YYYY"
                  )}
                </p>
              </div>
            </div>
            <div className="divider" />

            <div className="user-pricing-info">
              <div className="amount-title">
                <p>
                  {userDetailInfo?.balance?.balance >= 0
                    ? strings("descriptions.balance")
                    : "Total Due"}
                </p>
              </div>
              <div
                className={
                  userDetailInfo?.balance?.balance >= 0
                    ? "user-current-balance"
                    : "user-current-due"
                }
              >
                <h1>
                  {modifyCurrencyToSymbolAndValue(
                    userDetailInfo?.balance?.currency,
                    userDetailInfo?.balance?.balance / 100
                  )}
                </h1>
              </div>
              <div className="user-pricing-info">
                <p>
                  {" "}
                  {userDetailInfo?.card
                    ? `**** **** **** ${userDetailInfo?.card}`
                    : strings("descriptions.noCardSelected")}{" "}
                </p>
              </div>
            </div>
            <div className="divider" />

            <div className="user-plan-info">
              <div className="plan-header">
                <p>{strings("descriptions.pricingPlan")}</p>
              </div>
              <div className="plan">
                {userDetailInfo?.plan ? (
                  pricingPlan(userDetailInfo?.plan)
                ) : (
                  <h3>{strings("descriptions.noPricingPlanSelected")}</h3>
                )}
              </div>
            </div>

            <div className="divider" />

            <div className="final-sections">
              <div className="subtotal">
                <p>{strings("descriptions.fees")}</p>
                <p className="tax-amount">
                  {strings("descriptions.fee")}
                  {modifyCurrencyToSymbolAndValue(
                    userDetailInfo?.balance?.currency,
                    userDetailInfo?.directPaymentFee / 100
                  )}
                </p>
              </div>
              <div className="amount-due">
                <p>
                  {strings("descriptions.amountDueWithBalance", {
                    balance: modifyCurrencyToSymbol(
                      userDetailInfo?.balance?.currency
                    ),
                  })}
                </p>
                <p className="total-amount">
                  {modifyCurrencyToSymbolAndValue(
                    userDetailInfo?.balance?.currency,
                    userDetailInfo?.balance?.balance < 0
                      ? Math.abs(userDetailInfo?.balance?.balance / 100)
                      : 0
                  )}
                </p>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default LegacyWalletView;
